import instance from "../../helpers/AxiosInterceptor";

export const loadGroupes = () => instance.get("/reseau/groupes");
export const saveGroupe = (request) => instance.post("/reseau/groupes", JSON.stringify(request));
export const deleteGroupe = (id) => instance.delete(`/reseau/groupes/${id}`);

export const loadFerrailleurs = () => instance.get("/reseau/ferrailleurs");
export const saveFerrailleur = (request) => instance.post("/reseau/ferrailleurs", JSON.stringify(request));
export const deleteFerrailleur = (id) => instance.delete(`/reseau/ferrailleurs/${id}`);
